import React, { useState, useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { UnifiedHero } from '../components/UnifiedHero';
import { DualNatureSection } from '../components/DualNatureSection';
import { ServicesSection } from '../components/ServicesSection';
import { StudioWorksSection } from '../components/StudioWorksSection';
import { StatsSection } from '../components/StatsSection';
import { PortfolioSection } from '../components/PortfolioSection';
import { IndustrySection } from '../components/IndustrySection';
import { ClientsMarquee } from '../components/ClientsMarquee';
import { Testimonials } from '../components/ClientLogos';
import { FactoryTourSection } from '../components/FactoryTourSection';
import { VideoShowcase } from '../components/VideoShowcase';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
import { PageMeta } from '../components/PageMeta';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function HomePage() {
  const [heroData, setHeroData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/homepage`).then(r => setHeroData(r.data?.hero)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen">
      <PageMeta 
        title="IHG Industry | Architectural Metal Fabrication & Artistic Metalwork Dubai" 
        description="Engineering precision meets artistic vision. UAE's premier architectural metal fabrication specialist and artistic metalwork studio. Facades, interiors, sculptures, and bespoke finishes."
        keywords="architectural metalwork Dubai, metal fabrication UAE, facade panels, PVD coating, decorative screens, metal sculpture, artistic metalwork"
        type="website"
      />
      <Navbar />
      
      {/* Hero - Blended Industrial + Artistic */}
      <UnifiedHero heroData={heroData} />
      
      {/* The Dual Nature Statement */}
      <DualNatureSection />
      
      {/* Industrial Capabilities - Light Background */}
      <ServicesSection />
      
      {/* Studio Works Gallery - Dark Background */}
      <StudioWorksSection />
      
      {/* Stats - Achievement Numbers */}
      <StatsSection />
      
      {/* Featured Projects */}
      <PortfolioSection />
      
      {/* Industries We Serve */}
      <IndustrySection />
      
      {/* Client Logos */}
      <ClientsMarquee />
      <Testimonials />
      
      {/* Virtual Factory Tour */}
      <FactoryTourSection />
      
      {/* Video Gallery - Above Footer */}
      <VideoShowcase />
      
      {/* Experience Centre / Contact CTA */}
      <ContactSection showPartners={false} />
      
      <Footer />
      <ScrollToTop />
    </div>
  );
}
